import { useState } from 'react';
import { FileIconsMap } from '../../../components/ManualDataUploader/ManualUploadFileLink';
import MiniLoader from '../../../components/MiniLoader/MiniLoader';
import './SellerFillingFile.scss';

interface Props {
  filename: string;
  className?: string;
  onDownload: (
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  ) => () => void;
}

export default function SellerFillingFile({
  filename,
  className,
  onDownload,
}: Props) {
  const [isLoading, setIsLoading] = useState(false);

  const parts = filename.split('/');
  const name = parts[parts.length - 1];
  const ext = name.split('.').slice(-1)[0];

  return (
    <button
      className={`text-start ${className} SellerFillingFile w-100 bg-transparent p-3`}
      onClick={onDownload(setIsLoading)}
      type='button'
      disabled={isLoading}
    >
      <div className='d-flex align-items-center justify-content-between'>
        <div className='d-flex SellerFillingFile__info align-items-center'>
          <span className='SellerFillingFile__icon rounded-circle me-3'>
            {FileIconsMap[ext.toLowerCase()]}
          </span>
          <div>
            <div className='SellerFillingFile__name fw-600 aling-self-center'>
              {name}
            </div>
          </div>
        </div>
        {isLoading && (
          <MiniLoader className='MiniLoader--sm d-flex align-items-center justify-content-center' />
        )}
      </div>
    </button>
  );
}
